import ToolTip from 'patient-ping-remedy/packages/tool-tip';
import Icon, {ICONS} from 'patient-ping-remedy/packages/icon';
import {MessageThreadSummary} from '@/api/dto/message';
import {ItemWrapper, ItemContent} from '@/components/pages/messages/details/MessageThreadDetails.styles';

type Props = {
  messageThreadSummary?: MessageThreadSummary;
  concise?: boolean;
}

export default function MessageThreadUnits({ messageThreadSummary, concise }: Props) {
  if (!messageThreadSummary || !messageThreadSummary.units?.length) {
    return null;
  }

  const units = messageThreadSummary.units.join(', ');

  return (
    <ItemWrapper>
      <ToolTip text={units} position="bottom" type="dark">
        <ItemContent concise={concise}>
          <Icon iconClass={ICONS.building} iconSize={concise ? '1x' : 'lg'} />
          <span>{messageThreadSummary.units.length} {!concise && 'units'}</span>
        </ItemContent>
      </ToolTip>
    </ItemWrapper>
  );
}
